import React, { useState } from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Banner from "../../images/kontakt/bg_kontakt.png";

const Terminanfrage = () => {
  const [formData, setFormData] = useState({
        anrede: "",
        titel: "",
        vorname: "",
        nachname: "",
        svnr_4stellig: "",
        svnr_tt: "",
        svnr_mm: "",
        svnr_jj: "",
        email: "",
        telefon: "",
        betreff: "allgemeine-anfrage",
        anliegen: ""
    });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
        ...prev,
        [name]: value,
    }));
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        const res = await fetch("/api/termin-email", {
        method: "POST",
        headers: { "Content-Type": "application/json"},
            body: JSON.stringify(formData),
        });

        const result = await res.json();
        if (result.success) {
        setStatus("Ihre Nachricht wurde erfolgreich gesendet.");
        setFormData({
            anrede: "",
            titel: "",
            vorname: "",
            nachname: "",
            svnr_4stellig: "",
            svnr_tt: "",
            svnr_mm: "",
            svnr_jj: "",
            email: "",
            telefon: "",
            betreff: "allgemeine-anfrage",
            anliegen: "",
            einwilligung: false,
        });
        } else {
        setStatus("Fehler beim Senden. Bitte versuchen Sie es später erneut.");
        }
    } catch (err) {
        console.error(err);
        setStatus("Serverfehler. Bitte versuchen Sie es später erneut.");
    }
    };

    return (
    <main>
        <Header image={Banner} />
        <section className="content-section">
        <Navbar />

        <div className="page-container">
            <h1>Kontaktformular</h1>
            <form onSubmit={handleSubmit} className="kontakt-form">
            <div className="form-row">
                <label htmlFor="anrede">Anrede*:</label>
                <select id="anrede" name="anrede" value={formData.anrede} onChange={handleChange} required>
                <option value="">Bitte wählen</option>
                <option value="Herr">Herr</option>
                <option value="Frau">Frau</option>
                <option value="Divers">Divers</option>
                </select>

                <label htmlFor="titel">Titel:</label>
                <input type="text" id="titel" name="titel" value={formData.titel} onChange={handleChange} />
            </div>

            <div className="form-row">
                <label htmlFor="vorname">Vorname*:</label>
                <input type="text" id="vorname" name="vorname" value={formData.vorname} onChange={handleChange} required />

                <label htmlFor="nachname">Nachname*:</label>
                <input type="text" id="nachname" name="nachname" value={formData.nachname} onChange={handleChange} required />
            </div>

            <div className="form-row">
                <label>SozialversicherungsNr.*:</label>
                <div className="svnr-row">
                <input
                    className="svn-input"
                    type="text"
                    name="svnr_4stellig"
                    placeholder="1234"
                    maxLength="4"
                    value={formData.svnr_4stellig}
                    onChange={handleChange}
                    required
                />
                <input
                    className="svn-input"
                    type="text"
                    name="svnr_tt"
                    placeholder="TT"
                    maxLength="2"
                    value={formData.svnr_tt}
                    onChange={handleChange}
                    required
                />
                <input
                    className="svn-input"
                    type="text"
                    name="svnr_mm"
                    placeholder="MM"
                    maxLength="2"
                    value={formData.svnr_mm}
                    onChange={handleChange}
                    required
                />
                <input
                    className="svn-input"
                    type="text"
                    name="svnr_jj"
                    placeholder="JJ"
                    maxLength="2"
                    value={formData.svnr_jj}
                    onChange={handleChange}
                    required
                />
                </div>
            </div>

            <div className="form-row">
                <label htmlFor="email">Emailadresse*:</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>

            <div className="form-row">
                <label htmlFor="telefon">Telefonnummer*:</label>
                <input type="tel" id="telefon" name="telefon" value={formData.telefon} onChange={handleChange} required />
            </div>

            <div className="form-row">
                <label htmlFor="betreff">Betreff:</label>
                <select id="betreff" name="betreff" value={formData.betreff} onChange={handleChange}>
                <option value="allgemeine-anfrage">Allgemeine Anfrage</option>
                <option value="rueckruf">Rückruf</option>
                <option value="termin">Terminanfrage</option>
                </select>
            </div>

            <div className="form-row full-width">
                <label htmlFor="anliegen">Ihr Anliegen:</label>
                <textarea
                id="anliegen"
                name="anliegen"
                rows="6"
                placeholder="zB: Ich bitte um einen Rückruf, so bald als möglich"
                value={formData.anliegen}
                onChange={handleChange}
                ></textarea>
            </div>

            <div className="form-row checkbox-row">
                <label className="checkbox-label">
                Ich bin mit der Verarbeitung der eingegeben Daten zum Zwecke der Kontaktaufnahme und der Erledigung
                meines Anliegens einverstanden.*
                <input
                    type="checkbox"
                    name="einwilligung"
                    required
                />
                </label>
            </div>

            <button type="submit">Absenden</button>
            <p>{status}</p>
            </form>
        </div>
        </section>
        <Footer />
    </main>
    );
};

export default Terminanfrage;
